export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Download & Install',
      description: 'Download VOS VPN application for your device. Installation takes just a few minutes and works on all major platforms including Windows, Mac, iOS, and Android.',
      icon: 'ri-download-cloud-line'
    },
    {
      number: '02',
      title: 'Create Your Account',
      description: 'Sign up with your email address and choose your preferred subscription plan. Our simple registration process gets you started in seconds with secure authentication.',
      icon: 'ri-user-add-line'
    },
    {
      number: '03',
      title: 'Connect to Server',
      description: 'Select a server location from our global network or use our smart connect feature to automatically choose the best server for optimal speed and performance.',
      icon: 'ri-global-line'
    },
    {
      number: '04',
      title: 'Browse Securely',
      description: 'Enjoy complete online privacy and security. Your internet connection is now encrypted and your IP address is hidden, allowing you to browse freely and anonymously.',
      icon: 'ri-shield-check-line'
    }
  ];

  return (
    <section id="how-it-works" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-indigo-50 to-purple-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Getting started with VOS VPN is simple and straightforward. Follow these easy steps to secure your online presence
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 h-full border border-gray-100">
                <div className="w-16 h-16 flex items-center justify-center bg-indigo-600 rounded-xl mb-6">
                  <i className={`${step.icon} text-3xl text-white`}></i>
                </div>
                <div className="text-5xl font-bold text-indigo-100 mb-4">
                  {step.number}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-3xl text-indigo-300"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
